import Vue from "vue";
import Vuex from "vuex";
import projectsStore from "./modules/projectsModule/projectsStore";
import projectStore from "./modules/projectModule/projectStore";
import buildingStore from "./modules/buildingModule/buildingStore";
import floorStore from "./modules/floorModule/floorStore";
import roomStore from "./modules/roomModule/roomStore";
import loaderStore from "./modules/loaderStore";
import authStore from "./modules/authModule/authStore";
import newsStore from "./modules/newsModule/newsStore";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    projectsStore,
    projectStore,
    buildingStore,
    floorStore,
    roomStore,
    loaderStore,
    authStore,
    newsStore,
  },
});
